var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      ref: "modal",
      attrs: {
        title: "Generate File Notes Report",
        size: "md",
        "ok-text": "Run Report"
      },
      on: { hide: _vm.close },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { staticClass: "report-modal-wrapper" }, [
        _c("div", { staticClass: "row" }, [
          _c("label", { staticClass: "col-sm-4 control-label" }, [
            _vm._v("From Date:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _c("datepicker", {
                attrs: {
                  "calendar-button": true,
                  "calendar-button-icon": "fa fa-calendar",
                  "clear-button": true,
                  "clear-button-icon": "fa fa-times",
                  "bootstrap-styling": true,
                  format: "yyyy MMM dd",
                  typeable: _vm.isTypeable
                },
                model: {
                  value: _vm.startDate,
                  callback: function($$v) {
                    _vm.startDate = $$v
                  },
                  expression: "startDate"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("label", { staticClass: "col-sm-4 control-label" }, [
            _vm._v("To Date:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _c("datepicker", {
                attrs: {
                  "calendar-button": true,
                  "calendar-button-icon": "fa fa-calendar",
                  "clear-button": true,
                  "clear-button-icon": "fa fa-times",
                  "bootstrap-styling": true,
                  format: "yyyy MMM dd",
                  typeable: _vm.isTypeable
                },
                model: {
                  value: _vm.endDate,
                  callback: function($$v) {
                    _vm.endDate = $$v
                  },
                  expression: "endDate"
                }
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02bff90a", { render: render, staticRenderFns: staticRenderFns })
  }
}